export const launchingRouteDynamicActionController = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'transient',
          cond: 'isRouteDynamicAction',
        },
      },
    },
    transient: {
      always: [
        {
          target: 'waitingForSession',
          cond: 'isSessionNotResolved',
        },
        {
          target: 'setRouteDynamicAction',
        },
      ],
    },
    waitingForSession: {
      on: {
        SESSION_STATE_LOGGED_OUT: 'setRouteDynamicAction',
        SESSION_STATE_LOGGED_IN: 'setRouteDynamicAction',
      },
    },
    setRouteDynamicAction: {
      invoke: {
        src: 'setRouteDynamicActionData',
        onDone: {
          target: 'launchRouteDynamicAction',
          actions: {
            type: 'save',
            data: {
              routeDynamicAction: '$event.data.routeDynamicAction',
            },
            meta: {
              selectors: ['$action.data.routeDynamicAction'],
            },
          },
        },
      },
    },
    launchRouteDynamicAction: {
      always: [
        {
          target: 'loggedInRouteDynamicAction',
          cond: 'isLoggedInStateRequiredForRouteDynamicAction',
        },
        {
          target: 'loggedOutRouteDynamicAction',
          cond: 'isLoggedOutStateRequiredForRouteDynamicAction',
        },
      ],
    },
    loggedOutRouteDynamicAction: {
      always: [
        {
          target: 'performAction',
          cond: 'isLoggedOut',
        },
        {
          target: 'redirectToMainPage',
          cond: 'isLoggedIn',
        },
      ],
    },
    loggedInRouteDynamicAction: {
      always: [
        {
          target: 'performAction',
          cond: 'isLoggedIn',
        },
        {
          target: 'performActionWithLogin',
          cond: 'isLoggedOut',
        },
      ],
    },
    performActionWithLogin: {
      invoke: {
        src: 'launchLogin',
      },
      on: {
        SESSION_STATE_LOGGED_IN: 'waitForLayoutChangeEnd',
        LOGIN_MODAL_STATE_CLOSED: [
          {
            target: 'redirectToMainPage',
            cond: 'isNotAwaitingLogin',
          },
        ],
      },
    },
    waitForLayoutChangeEnd: {
      on: {
        LAYOUT_CHANGE_END: 'performAction',
      },
    },
    performAction: {
      invoke: {
        src: 'performRouteDynamicAction',
      },
      on: {
        REGISTER_MODAL_STATE_CLOSED: 'redirectToMainPage',
        DEPOSIT_MODAL_STATE_CLOSED: 'redirectToMainPage',
      },
      onDone: {
        target: 'stop',
      },
    },
    redirectToMainPage: {
      invoke: {
        src: 'redirectToMainPage',
      },
      onDone: {
        target: 'stop',
      },
    },
    stop: {
      type: 'final',
    },
  },
};
